<template>
    <div>
        <b-card
            class="question mb-2"
            no-body
        >
            <template #header>
                <question-print-view-warning v-if="question && question.print_view" />
                <div class="question-header-content">
                    <div class="d-flex align-items-center">
                        <div class="d-flex flex-grow-1 align-items-center form-inline">

                            <div class="flex-grow-1">
                                <div class="mr-3 text-capitalize">
                                    {{ formattedQuestionType(question.type) }}
                                </div>
                            </div>

                            <div class="ml-auto">
                                <b-dropdown
                                    size="sm"
                                    variant="secondary"
                                    dropleft
                                >
                                    <template #button-content>
                                        <font-awesome-icon :icon="['fad', 'cog']" />
                                    </template>
                                    <b-dropdown-item
                                        @click.prevent="editQuestion(question)"
                                        :disabled="disabled"
                                    >
                                        <font-awesome-icon :icon="['fad', 'edit']" class="text-primary" fixed-width />
                                        Edit
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        @click.prevent="deleteQuestion(question)"
                                        :disabled="disabled"
                                    >
                                        <font-awesome-icon :icon="['fad', 'trash']" class="text-danger" fixed-width />
                                        Delete
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <question-version-switcher :question="question">
                <question-content
                    :question="question"
                />
            </question-version-switcher>

            <question-modal
                v-model="show_question_modal"
                :article="article"
                :question="question"
                @update="saveQuestion"
                @hide="show_question_modal = false"
            />
        </b-card>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import QuestionContent from '@/components/questions/Index'
import QuestionPrintViewWarning from '@/components/questions/QuestionPrintViewWarning'
import QuestionVersionSwitcher from '@/components/questions/QuestionVersionSwitcher'
import QuestionModal from '@/components/modals/questions/QuestionModal'
import {formattedQuestionType} from '@/common/formattedQuestionType'

export default {
    data: () => ({
        show_question_modal: false,
    }),
    props: [
        'article',
        'question',
        'item',
        'disabled',
    ],
    components: {
        QuestionContent,
        QuestionModal,
        QuestionPrintViewWarning,
        QuestionVersionSwitcher
    },
    methods: {
        formattedQuestionType,
        editQuestion() {
            this.show_question_modal = true
        },
        saveQuestion(question) {
            this.axios.post('/api/questions/update/' + question.id, {
                content: question.content,
                print_view: question.print_view,
                standards: question.standards
            })
                .then(() => {
                    this.$emit('update')

                    this.show_question_modal = false
                })
        },
        deleteQuestion(question) {
            this.$swal({
                html: 'Are you sure you want to delete this question?',
                showCancelButton: true,
                confirmButtonText: 'Delete Question',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('deleteRelatedMediaQuestion', question.id)
                        .then(() => {
                            this.$emit('delete')
                        })
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.question::v-deep .card-header {
    padding: 0;
}

.question-header-content {
    padding: 1.25rem;
}
</style>
